module.exports = __webpack_public_path__ + "static/media/no-new-applications.d6ec52d9.svg";